import type { ViewerClientSpecMap, AppSpecData, SpecMapBuilderComponent } from '@wix/thunderbolt-symbols'

export type EditableComponentUrls = {
	JSX: string
	SDK: string
	npmModuleName: string
}

// TODO should be removed once a moduleSpecifier is added to the components' manifest
const FALLBACK_COMPONENTS_MAP = {
	'platform.builder.6a30caff-5dc3-4e4c-ba70-19db988f5830_1f0108be-06bb-4a81-9c55-a1cbd223926c': '@wix/editor-react-components/BoxContainer',
	'platform.builder.6a30caff-5dc3-4e4c-ba70-19db988f5830_4190f51c-3836-49f6-8114-96219c165b29': '@wix/editor-react-components/Button',
	'platform.builder.6a30caff-5dc3-4e4c-ba70-19db988f5830_1392cc2d-20e7-411a-8b60-6e0af55b8ece': '@wix/editor-react-components/CollapsibleText',
	'platform.builder.6a30caff-5dc3-4e4c-ba70-19db988f5830_bf8a38af-5784-47d5-92d3-3627a6a60bc6': '@wix/editor-react-components/GoogleMap',
	'platform.builder.6a30caff-5dc3-4e4c-ba70-19db988f5830_e81a1c4b-8b8c-4a7e-9f2d-1a3b4c5d6e7f': '@wix/editor-react-components/HTMLComponent',
	'platform.builder.6a30caff-5dc3-4e4c-ba70-19db988f5830_0bfa7aab-081b-431b-adb2-1b1062e8f21a': '@wix/editor-react-components/Image3',
	'platform.builder.6a30caff-5dc3-4e4c-ba70-19db988f5830_469ad5da-7dec-4577-8640-3d9220917692': '@wix/editor-react-components/LegacyAppWidget',
	'platform.builder.6a30caff-5dc3-4e4c-ba70-19db988f5830_4489ce49-e5d8-4aa8-9762-db567ee4eef9': '@wix/editor-react-components/LegacyContainer',
	'platform.builder.6a30caff-5dc3-4e4c-ba70-19db988f5830_2feb9967-09c9-49ef-9ded-0e515e5c5873': '@wix/editor-react-components/LegacyMultiStateBox',
	'platform.builder.6a30caff-5dc3-4e4c-ba70-19db988f5830_d2ff230a-71c3-4e58-8742-d68f69a2de0b': '@wix/editor-react-components/Line',
	'platform.builder.6a30caff-5dc3-4e4c-ba70-19db988f5830_241afef1-74bd-4a10-843f-ac4928c25882': '@wix/editor-react-components/LinkBar',
	'platform.builder.6a30caff-5dc3-4e4c-ba70-19db988f5830_4190f51c-3836-49f6-8114-96219c165b30': '@wix/editor-react-components/Logo',
	'platform.builder.6a30caff-5dc3-4e4c-ba70-19db988f5830_3f27c3f4-5a2b-4b2c-9b14-05d9c0c6d5ec': '@wix/editor-react-components/Menu',
	'platform.builder.6a30caff-5dc3-4e4c-ba70-19db988f5830_4bd21d9e-bbe1-4097-a519-9561b42f3578': '@wix/editor-react-components/Slideshow',
	'platform.builder.6a30caff-5dc3-4e4c-ba70-19db988f5830_5df938dd-345f-49bc-9623-aff6c9945efb': '@wix/editor-react-components/SlotsPlaceholder',
	'platform.builder.6a30caff-5dc3-4e4c-ba70-19db988f5830_ac17f3cb-c4f8-4f35-be4f-81ef456cce7e': '@wix/editor-react-components/SocialPlayerFacebook',
	'platform.builder.6a30caff-5dc3-4e4c-ba70-19db988f5830_57cac74a-f0dc-416b-9f09-0c38799c3402': '@wix/editor-react-components/SocialPlayerInstagram',
	'platform.builder.6a30caff-5dc3-4e4c-ba70-19db988f5830_fe00a488-978a-440c-aead-b43ab9795ad2': '@wix/editor-react-components/SocialPlayerSnapchat',
	'platform.builder.6a30caff-5dc3-4e4c-ba70-19db988f5830_1bc7cd37-5d90-48a6-a2c1-de94f77d4fd6': '@wix/editor-react-components/SocialPlayerTikTok',
	'platform.builder.6a30caff-5dc3-4e4c-ba70-19db988f5830_8ec522c3-d8dd-43d8-9f07-1c4c1bb09d80': '@wix/editor-react-components/SocialPlayerVimeo',
	'platform.builder.6a30caff-5dc3-4e4c-ba70-19db988f5830_4190f51c-3836-49f6-8114-96219c165b20': '@wix/editor-react-components/SocialPlayerYoutube',
	'platform.builder.6a30caff-5dc3-4e4c-ba70-19db988f5830_4dbf752a-8a67-4149-87e7-6132bc25d3c2': '@wix/editor-react-components/SvgImage',
	'platform.builder.6a30caff-5dc3-4e4c-ba70-19db988f5830_cb6af77a-b0d6-424f-ba09-d4944e1e35c2': '@wix/editor-react-components/TestComp',
	'platform.builder.6a30caff-5dc3-4e4c-ba70-19db988f5830_8441a520-52ed-4c32-9b9d-0aa8c2604b01': '@wix/editor-react-components/VideoUpload',
	'platform.builder.6a30caff-5dc3-4e4c-ba70-19db988f5830_4220f51c-7462-49f6-7352-14219c165b28': '@wix/editor-react-components/WRichText'
}

const buildEditorReactComponentMapping = (
	urlExtractor: (resources: Record<string, any>) => string | undefined,
	keyTransformer: (moduleSpecifier: string) => string = (key) => key
): Record<string, string> => {
	const mapping: Record<string, string> = {}

	// @ts-expect-error
	const clientSpecMap = (typeof window !== 'undefined' ? window?.rendererModel?.clientSpecMap : undefined) as ViewerClientSpecMap | undefined
	if (!clientSpecMap) {
		return mapping
	}

	// TODO will be replaced with a mapping of the widget and its dependencies (instead of going through ALL the new model components)
	Object.values(clientSpecMap).forEach((spec: AppSpecData) => {
		if (spec?.components && Array.isArray(spec.components)) {
			spec.components
				.filter((comp: SpecMapBuilderComponent) => comp?.type === 'EDITOR_REACT_COMPONENT')
				.forEach((comp: SpecMapBuilderComponent) => {
					const { type: builderType, resources } = comp.data || {}
					const url = urlExtractor(resources)
					const moduleSpecifier = resources?.client?.moduleSpecifier || FALLBACK_COMPONENTS_MAP[builderType as keyof typeof FALLBACK_COMPONENTS_MAP] || builderType

					if (moduleSpecifier && url) {
						mapping[keyTransformer(moduleSpecifier)] = url
					}
				})
		}
	})

	return mapping
}

export const getEditorReactComponentsJsxMapping = (): Record<string, string> => {
	return buildEditorReactComponentMapping(
		(resources) => resources?.client?.componentUrl
	)
}

export const getEditorReactComponentsSdkMapping = (): Record<string, string> => {
	return buildEditorReactComponentMapping(
		(resources) => resources?.sdk?.url,
		(moduleSpecifier) => `${moduleSpecifier}/sdk`
	)
}
